import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { capturePersistAndStripCustomerAuthHandoffFromWindow } from './app/public/customer-auth-url-handoff';
import { environment } from './environments/environment';
import { gtm } from './app/shared/google-tag-manager';

// Capture authData, persist to localStorage, then scrub the bar before Angular
// boots — so a reload cannot lose the session and the token never enters the
// Router UrlTree (#11246). This is the single owner of capture → persist →
// strip: it runs once, here, before anything can inject CustomerAuthService,
// which is why that service's constructor does no handoff work. The service's
// parseAndSetAuthFromUrl() is the lazy consumer for what this cannot see
// (search-string links already in the wild, a fragment a redirect rewrote).
capturePersistAndStripCustomerAuthHandoffFromWindow();

// Load Google Tag Manager only in prod environment
if (environment.production) {
  const ADMIN_GTM = 'GTM-KL7TDSZ';
  const CUSTOMER_GTM = 'GTM-KBX9VSW';

  const gtmKey =
    window.location.hostname === 'admin.gonnaorder.com'
      ? ADMIN_GTM
      : CUSTOMER_GTM;
  gtm(gtmKey);
  console.log('Google Tag Manager initiated with key: ' + gtmKey);
}

const RMSScript = document.createElement('script');
RMSScript.type = 'text/javascript';
RMSScript.src = 'assets/rxp-js.js';
document.head.appendChild(RMSScript);

const vivaScript = document.createElement('script');
vivaScript.type = 'text/javascript';
vivaScript.src = 'https://demo.vivapayments.com/web/checkout/v2/js';
document.head.appendChild(vivaScript);

const treeviewScript = document.createElement('script');
treeviewScript.type = 'text/javascript';
treeviewScript.src = 'assets/tree-structure/treeview.js';
document.head.appendChild(treeviewScript);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
